import Vue from 'vue'
/* eslint-disable @typescript-eslint/camelcase */
if ((window as any).__POWERED_BY_QIANKUN__) {
  // eslint-disable-next-line no-undef
  __webpack_public_path__ = (window as any).__INJECTED_PUBLIC_PATH_BY_QIANKUN__
}

Vue.prototype.$qiankun = !!(window as any).__POWERED_BY_QIANKUN__
Vue.prototype.$baseUrl = (window as any).__POWERED_BY_QIANKUN__ ? process.env.VUE_APP_BASE_URL : ''
